import gql from 'graphql-tag';

export const GET_VIDEO_SHARE_SETTING = gql`
  query GetVideoShareSetting($videoId: String!) {
    getVideoShareSetting(videoId: $videoId) {
      videoShareSettingId
      videoId
      shareStatus
      accessLevel
      expiryDate
      createdByUserId
      organisationId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_VIDEO_SHARE_SETTING = gql`
  mutation UpdateVideoShareSetting($videoId: String!, $input: UpdateVideoShareSettingInput!) {
    updateVideoShareSetting(videoId: $videoId, input: $input) {
      videoShareSettingId
      videoId
      shareStatus
      accessLevel
      expiryDate
      createdByUserId
      organisationId
      createdAt
      updatedAt
    }
  }
`;

export const GET_VIDEO_PERMISSIONS = gql`
  query GetVideoPermissions($videoId: String!) {
    getVideo(videoId: $videoId) {
      videoId
      permissions
    }
  }
`;

export const GET_RESOURCE_ROLES = gql`
  query GetResourceRoles($organisationId: String!) {
    getRoles(roleType: RESOURCE, organisationId: $organisationId) {
      roleId
      name
    }
  }
`;

export const GET_ROLE_ASSIGNMENTS = gql`
  query GetRoleAssignments($resourceId: String!) {
    getRoleAssignments(resourceId: $resourceId) {
      organisation {
        organisationId
      }
      role {
        roleId
        name
      }
      canSearch
      public
      isPrivate
      resourceRoleAssignmentId
      resourceType
    }
  }
`;

export const UPDATE_ROLE_ASSIGNMENTS = gql`
  mutation UpdateRoleAssignments(
    $resourceId: String!
    $resourceType: String!
    $assignmentIdsToDelete: [String]
    $assignmentsToUpsert: [RoleAssignmentInput!]
  ) {
    updateRoleAssignments(
      resourceId: $resourceId
      resourceType: $resourceType
      assignmentIdsToDelete: $assignmentIdsToDelete
      assignmentsToUpsert: $assignmentsToUpsert
    ) {
      organisation {
        organisationId
      }
      role {
        roleId
        name
      }
      canSearch
      public
      isPrivate
      resourceRoleAssignmentId
    }
  }
`;
